export const interestedCategoriesOptions = [
  {
    category: "Technology & Development",
    options: [
      "Web Development",
      "Mobile App Development",
      "Data Science",
      "Machine Learning",
      "Artificial Intelligence",
      "Cloud Computing",
      "Cybersecurity",
      "Blockchain",
      "DevOps",
      "Game Development",
    ],
  },
  {
    category: "Business & Entrepreneurship",
    options: [
      "Entrepreneurship",
      "Business Analytics",
      "Leadership & Management",
      "Project Management",
      "Digital Marketing",
      "Finance & Accounting",
      "E-commerce",
      "Sales & Negotiation",
      "Startup Strategy",
      "Investment & Trading",
    ],
  },
  {
    category: "Design & Creativity",
    options: [
      "Graphic Design",
      "UI/UX Design",
      "Interior Design",
      "Fashion Design",
      "3D Animation",
      "Motion Graphics",
      "Game Art Design",
      "Design Thinking",
      "Adobe Creative Suite",
      "Product Design",
    ],
  },
  {
    category: "Health & Wellness",
    options: [
      "Nutrition & Diet",
      "Fitness Training",
      "Mental Health",
      "Yoga & Meditation",
      "Personal Development",
      "Therapy & Counseling",
      "Health Coaching",
      "First Aid & CPR",
      "Public Health",
      "Ayurveda & Natural Healing",
    ],
  },
  {
    category: "Art & Humanities",
    options: [
      "Photography",
      "Writing & Publishing",
      "History & Culture",
      "Philosophy",
      "Languages & Literature",
      "Fine Arts",
      "Music Theory & Instruments",
      "Art History",
      "Calligraphy",
      "Storytelling",
    ],
  },
  {
    category: "Science & Engineering",
    options: [
      "Physics",
      "Chemistry",
      "Biology",
      "Mathematics",
      "Civil Engineering",
      "Electrical Engineering",
      "Mechanical Engineering",
      "Environmental Science",
      "Astronomy",
      "Robotics",
    ],
  },
  {
    category: "Languages",
    options: [
      "English",
      "Spanish",
      "French",
      "German",
      "Hindi",
      "Mandarin Chinese",
      "Arabic",
      "Japanese",
      "Korean",
      "Russian",
    ],
  },
  {
    category: "Lifestyle & Skills",
    options: [
      "Cooking & Baking",
      "Travel & Culture",
      "Home Improvement",
      "Gardening",
      "Parenting",
      "Pet Training",
      "Beauty & Makeup",
      "Fashion Styling",
      "Productivity & Time Management",
      "Public Speaking",
    ],
  },
];
